export default __webpack_public_path__ + "static/media/imgLat2.4d2674b1.png";